import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    chipContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    }
}));
